export const transformGapsIntoOpportunitiesWorkshop = {
  '@context': 'https://schema.org',
  '@type': 'Event',
  name: 'Transform gaps into opportunities',
  startDate: '2023-09-21',
  duration: '2.5h',
  location: {
    '@type': 'Place',
    name: 'Mindspace, Zimmerstraße, Berlin',
  },
  description:
    'Optimize your business outcomes using service blueprints. In this session, Oskar Kwitek will guide you through the essentials of rapid prototyping and its role in scaling AI solutions.',
  organizer: {
    '@type': 'Organization',
    name: 'Boldare',
    url: 'https://www.boldare.com',
  },
  performer: {
    '@type': 'Person',
    name: 'Jagoda Podrucka',
    jobTitle: 'Product Designer at Boldare',
  },
  url: 'https://www.boldare.com/transform-gaps-into-opportunities-workshop/',
};
